import React from 'react';
import styled from '@emotion/styled';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import { Edit2 } from 'react-feather';

type Props = {
  title: React.ReactNode;
  isEditing: boolean;
  disabled?: boolean;
  onEdit: () => unknown;
  onSave: () => unknown;
  onCancel: () => unknown;
};

export const EditFormHeader = ({ disabled = false, ...props }: Props) => {

  return (
    <SectionHeader>
      <SectionTitle>
        {props.title}
      </SectionTitle>
      <SectionEditForm
        isEditing={props.isEditing}
        disabled={disabled}
        onEdit={props.onEdit}
        onSave={props.onSave}
        onCancel={props.onCancel} />
    </SectionHeader>
  );
};

type SectionEditFormProps = {
  isEditing: boolean;
  disabled?: boolean;
  onEdit: () => unknown;
  onSave: () => unknown;
  onCancel: () => unknown;
};

export const SectionEditForm = (props: SectionEditFormProps) => {

  return (
    <Stack direction="row" spacing={1}>
      {(props.isEditing && !props.disabled) && (
        <IconButton
          size='small'
          disabled={props.disabled}
          onClick={props.onSave}>
          <CheckButton />
        </IconButton>
      )}
      {props.isEditing && (
        <IconButton
          size='small'
          onClick={props.onCancel}>
          <CloseButton />
        </IconButton>
      )}
      {!props.isEditing && (
        <IconButton size='small' onClick={props.onEdit}>
          <EditButton />
        </IconButton>
      )}
    </Stack>
  );
};

export const PageTitle = (props: ChildrenProps) => {

  return (
    <Typography sx={theme => ({
      display: 'flex',
      alignItems: 'center',
      flexGrow: 1,
      color: theme.palette.black.main,
      fontSize: 24,
      fontWeight: 'bold',
    })}>
      {props.children}
    </Typography>
  );
};

export const PageHeader = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  marginBottom: 15,
  padding: 5,
});

export const PageRoot = styled('div')({
  padding: 15,
  maxWidth: 1000,
});

export const SectionTitle = (props: ChildrenProps) => (
  <Typography
    sx={theme => ({
      flexGrow: 1,
      color: theme.palette.black.main,
      fontSize: 18,
      fontWeight: 600,
      lineHeight: '34px',
    })}>
    {props.children}
  </Typography>
);

export const SectionHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  borderBottom: `1px solid ${theme.palette.gray.light1}`,
  padding: 5,
  marginBottom: 8,
}));

export const SectionBody = styled('div')({
  padding: 5,
});

const EditButton = styled(Edit2)(({ theme }) => ({
  color: theme.palette.primary.main,
}));
const CloseButton = styled(CloseIcon)(({ theme }) => ({
  color: theme.palette.red.main,
}));
const CheckButton = styled(CheckIcon)(({ theme }) => ({
  color: theme.palette.green.main,
}));